// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RgaA","field":"styles_field__28g92","fieldCol":"styles_fieldCol__RKqSC","diffCol":"styles_diffCol__2E-lF","diff":"styles_diff__3O3cC"};